// 환불 사유 전용 필드(refund_reason)를 사람이 읽을 수 있는 배지 정보로 변환한다.
// 백엔드는 이제 문자열이 아닌 사유 코드를 refund_reason 컬럼에 저장하므로,
// 화면에서는 코드만 신뢰해서 분류하면 된다. (레거시 행은 설명 문구로 보완)

export interface RefundReasonInfo {
  code: string;
  label: string;
  icon: string;
  cls: string;
  isAuto: boolean;
}

const REASON_CONFIG: Record<string, Omit<RefundReasonInfo, "code">> = {
  timeout: {
    label: "타임아웃 자동 환불",
    icon: "ri-timer-flash-line",
    cls: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    isAuto: true,
  },
  send_fail: {
    label: "발송 실패 자동 환불",
    icon: "ri-refund-2-line",
    cls: "bg-rose-500/15 text-rose-300 border-rose-500/30",
    isAuto: true,
  },
  force_cancel: {
    label: "발송 중단 환불",
    icon: "ri-stop-circle-line",
    cls: "bg-orange-500/15 text-orange-300 border-orange-500/30",
    isAuto: true,
  },
  schedule_cancel: {
    label: "예약 취소 환불",
    icon: "ri-calendar-close-line",
    cls: "bg-sky-500/15 text-sky-300 border-sky-500/30",
    isAuto: true,
  },
  admin_adjust: {
    label: "관리자 환불",
    icon: "ri-shield-check-line",
    cls: "bg-teal-500/15 text-teal-300 border-teal-500/30",
    isAuto: false,
  },
};

// 전용 필드가 없던 시절(레거시) 기록은 설명 문구에서 사유를 추론한다.
function inferReasonFromDescription(description: string | null): string | null {
  const d = description || "";
  if (d.includes("타임아웃")) return "timeout";
  if (d.includes("분할 발송 실패") || d.includes("발송 실패")) return "send_fail";
  if (d.includes("중단")) return "force_cancel";
  if (d.includes("취소")) return "schedule_cancel";
  return null;
}

export function resolveRefundReason(
  reason: string | null | undefined,
  description: string | null | undefined,
): RefundReasonInfo | null {
  const code = reason && REASON_CONFIG[reason] ? reason : inferReasonFromDescription(description ?? null);
  if (!code || !REASON_CONFIG[code]) return null;
  return { code, ...REASON_CONFIG[code] };
}

// 자동 환불(타임아웃·발송 실패·중단·예약 취소)인지 여부. 관리자 수동 환불은 제외.
export function isAutoRefund(
  reason: string | null | undefined,
  description: string | null | undefined,
): boolean {
  const info = resolveRefundReason(reason, description);
  return !!info && info.isAuto;
}